<app-page-header [heading]="'Unit'" [icon]="'fa-medkit'" style="height:100px;"></app-page-header>
<div *ngIf="user_rights.ADD == '1'" class="page-panel">
  <div class="clearfix"></div>
  <div class="clearfix"></div>
  <div class="clearfix"></div>
  <div class="row col-lg-12">
    <div class="form-group col-lg-4">
      <label>Description</label><span class="text-danger">&nbsp;*</span>
      <input [(ngModel)]="unit_data.unit_name" class="form-control " name="desc" type="text">
    </div>
    <div class="form-group col-lg-4">
      <label>Short Form</label><span class="text-danger">&nbsp;*</span>
      <input [(ngModel)]="unit_data.short_name" class="form-control " name="name" type="text">
    </div>
    <div class="clearfix"></div>
    <div class="clearfix"></div>
    <div class="clearfix"></div>
    <div class="row container">
      <div class="col-lg-7 pull-right">
        <button (click)="saveUnit();" *ngIf="user_rights.ADD == '1'" class="btn btn-info btn-sm ng-star-inserted"
                type="button">&nbsp;Save&nbsp;
        </button>&nbsp;&nbsp;&nbsp;
        <button (click)="clearUnit();" *ngIf="user_rights.ADD == '1'" class="btn btn-danger btn-sm" type="button">
          &nbsp;Clear&nbsp;
        </button>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
  <hr>
  <div class="clearfix"></div>
  <div class="clearfix"></div>
  <div class="row col-12 ">
    <div class="col-lg-8">
      <h4 class="list-header">Unit List</h4>
    </div>
    <div class="clearfix"></div>
    <div class="col-12">
      <table class="table tbl table-hover table-striped table-bordered">
        <thead>
        <tr class="text-center">
          <th width="5%">Sl#</th>
          <th>Description</th>
          <th width="15%">Short Name</th>
          <th width="10%">Action</th>
        </tr>
        <tr *ngIf="(data | json) == '[]'">
          <td class="text-center" colspan="10">No data to list</td>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let unit of data;let i=index" style="font-size: 12px">
          <td>{{ start + i + 1 }}</td>
          <td>{{ unit.UNIT_DESC }}</td>
          <td>{{ unit.SHORT_FORM }}</td>
          <td>
            <button (click)="editUnit(unit);" *ngIf="user_rights.EDIT == '1'" alt="Edit" class="btn btn-sm btn-default"
                    title="Edit"><i class="fa fa-edit"></i></button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

